export default __webpack_public_path__ + "static/spinner-43ff5fff93183f6fd8f7950152e55335.svg";